import { BusGoogleProvider } from "./google";
// import { BusInsiderProvider } from "./insider"; // İleride eklenecek
// import { BusSegmentifyProvider } from "./segmentify"; // İleride eklenecek
import appConfig from "@/configs/app-config";

/**
 * Otobüs Analytics Service
 * Tüm provider'ları yönetir (Google, Insider, Segmentify vb.)
 */
export class BusAnalyticsService {
  constructor() {
    this.providers = [];

    // Google Analytics
    if (appConfig.THIRD_PARTY_OPTIONS.GOOGLE.ANALYTICS.ACTIVE) {
      this.providers.push(new BusGoogleProvider());
    }

    // Insider (ileride eklenecek)
    // if (appConfig.THIRD_PARTY_OPTIONS.INSIDER.ACTIVE) {
    //   this.providers.push(new BusInsiderProvider());
    // }

    // Segmentify (ileride eklenecek)
    // if (appConfig.THIRD_PARTY_OPTIONS.SEGMENTIFY.ACTIVE) {
    //   this.providers.push(new BusSegmentifyProvider());
    // }
  }

  /**
   * Event'i tüm aktif provider'lara gönderir
   * @param {string} event - Event tipi
   * @param {object} data - Event verisi
   */
  track(event, data) {
    this.providers.forEach((provider) => {
      try {
        provider.track(event, data);
      } catch (error) {
        console.error(`Bus Analytics Provider Error:`, error);
      }
    });
  }
}

export const busService = new BusAnalyticsService();
